<template>
    <div class="page-bg">
    <div class="container pt-4">

        <div class="mb-3">
            <router-link to="/journal" class="btn btn-sm btn-outline-secondary">
                ← Journal
            </router-link>
        </div>

        <div v-if="loading" class="text-center py-5">
            <div class="spinner-border text-secondary" role="status"></div>
        </div>

        <div v-else-if="error" class="alert alert-danger">{{ error }}</div>

        <div v-else class="card">
            <div class="card-body">
                <div v-if="!targetEvent" class="text-muted">
                    Event not found for this time.
                </div>
                <template v-else>
                    <div class="d-flex align-items-center justify-content-between mb-2">
                        <div class="d-flex align-items-center">
                            <span class="hero-symbol me-3">{{ targetEvent.symbol }}</span>
                            <span class="hero-label fw-bold">{{ targetEvent.label }}</span>
                        </div>
                        <span class="hero-time text-muted">{{ targetEvent.time }}</span>
                    </div>
                    <p class="mb-1">{{ targetEvent.line }}</p>
                    <p class="text-muted small mb-0">
                        {{ formattedDate }}
                        <span v-if="city"> · {{ city.name }}<span v-if="city.region_name">, {{ city.region_name }}</span>
                        <span v-if="city.country_flag" class="ms-1">{{ city.country_flag }}</span></span>
                    </p>
                </template>
            </div>
        </div>

    </div>
    </div>
</template>

<script>
import astra from '@/api/astra'
import locci from '@/api/locci'

export default {
    name: 'JournalEventDetail',
    data() {
        return {
            loading: true,
            city: null,
            targetEvent: null,
            error: null,
        }
    },
    computed: {
        citySlug() { return this.$route.query.city },
        date()     { return this.$route.query.date },
        minute()   { return parseInt(this.$route.query.minute) },
        formattedDate() {
            if (!this.date) return ''
            const d = new Date(this.date + 'T12:00:00')
            return d.toLocaleDateString(undefined, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })
        },
    },
    async mounted() {
        if (!this.citySlug || !this.date || isNaN(this.minute)) {
            this.error = 'Invalid event link — city, date, and minute are required.'
            this.loading = false
            return
        }
        try {
            const cityRes = await locci.fetchCity(this.citySlug)
            this.city = cityRes.data
            const { lat, lon, timezone_slug } = this.city
            const journalRes = await astra.fetchJournal({
                lat,
                lon,
                timezoneSlug: timezone_slug,
                date1: this.date,
            })
            const events = journalRes.data.events || []
            this.targetEvent = events.find(e => e.minute_of_day === this.minute) || null
        } catch {
            this.error = 'Could not load event data.'
        } finally {
            this.loading = false
        }
    },
}
</script>

<style scoped>
.page-bg {
    min-height: 100vh;
    background-color: #fff;
}
.hero-symbol {
    font-size: 2rem;
    line-height: 1;
}
.hero-label {
    font-size: 1.3rem;
}
.hero-time {
    font-size: 1rem;
}
</style>
